import { render, staticRenderFns } from "./CashierPage.vue?vue&type=template&id=295e9a8f&scoped=true&"
import script from "./CashierPage.vue?vue&type=script&lang=js&"
export * from "./CashierPage.vue?vue&type=script&lang=js&"
import style0 from "./CashierPage.vue?vue&type=style&index=0&id=295e9a8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e9a8f",
  null
  
)

export default component.exports